/**
 * CartActions.js — Wine Engine "View Basket" row under wine listings.
 *
 * OVERRIDES: base CartActions ("View cart").
 * Parity: old createWineListing — only "View Basket". Hidden while Build Wine
 * Box drawer is active (old omitted the footer in build-box mode).
 */

import { emit, on, getState } from "../../../core/state.js";

export default class CartActions {
  render() {
    const row = document.createElement("div");
    row.className = "ws-cart-actions ws-we-cart-actions";
    // Indent to match guided chips / old option-button column (ss2 right).
    row.style.paddingLeft = "calc(var(--ws-avatar-size, 24px) + var(--ws-avatar-gap, 8px))";

    const sync = () => {
      const hide = !!getState().buildBox?.active;
      row.hidden = hide;
      row.style.display = hide ? "none" : "";
    };
    sync();
    on("ws-build-box-changed", sync);

    const view = document.createElement("button");
    view.type = "button";
    view.className = "ws-cart-action-btn ws-we-view-basket";
    view.textContent = "View Basket";
    view.setAttribute("data-view-cart", "");
    view.addEventListener("click", () => emit("ws-cart-open"));
    row.appendChild(view);

    return row;
  }
}
